import { render, staticRenderFns } from "./Hackaton.vue?vue&type=template&id=01d5be6e&scoped=true&"
import script from "./Hackaton.vue?vue&type=script&lang=ts&"
export * from "./Hackaton.vue?vue&type=script&lang=ts&"
import style0 from "./Hackaton.vue?vue&type=style&index=0&id=01d5be6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d5be6e",
  null
  
)

export default component.exports